
import { useDispatch } from 'react-redux'

import DialogTitle from '@mui/material/DialogTitle'
import Dialog from '@mui/material/Dialog'
import CloseIcon from '@mui/icons-material/Close'
import { DialogActions, DialogContent, IconButton } from '@mui/material'

import './validateProfit.css'

import { iniRequestValidation } from '../../../redux/actions/pptos'

export const RequestValidation = ({ budgetId, open, setOpen }) => {

    const dispatch = useDispatch()

    const handleRequest = () => {
        dispatch(iniRequestValidation(budgetId))
        setOpen(false)
    }

    return (
        <Dialog onClose={() => setOpen(false)} open={open} className='p-dialog-approve'>
            <DialogTitle className='ColorTitleDocument' id="scroll-dialog-title">
                <IconButton
                    aria-label="close"
                    style={{ padding: '0', float: 'right' }}
                    onClick={() => setOpen(false)}
                >
                    <CloseIcon
                        style={{ color: '#78667E' }}
                    />
                </IconButton>
            </DialogTitle>
            <DialogContent className='content'>
                <div className='d-flex justify-content-center p-icons'>
                    <i className='bi bi-send-check' style={{ color: '#f85f6a', fontSize: '30px' }}></i>
                </div>
                <div className='text'>
                    <h3>Solicitar validación</h3>
                    <p>¿Estás seguro de enviar</p>
                    <p>la solicitud?</p>
                </div>
            </DialogContent>
            <DialogActions className='d-flex justify-content-center mt-3 mb-2 p-actions'>
                <button className='cancel' onClick={() => setOpen(false)}>Cancelar</button>
                <button className='approve' onClick={handleRequest}>Solicitar</button>
            </DialogActions>
        </Dialog>
    );

}